// extracted by mini-css-extract-plugin
export default {"wrapper":"DE-z","response":"EE-z","error":"FE-z","disabled":"GE-z","buttons":"HE-z","feedbackQuestionSection":"IE-z","yesNoWrapper":"JE-z"};